export type ProgramType =
  'GRADUATE_PROGRAM' | 'GRADUATE_GROUP' | 'PROFESSIONAL_PROGRAM' | 'DESIGNATED_EMPHASIS' | 'GRADUATE_CERTIFICATE';

export const ProgramTypes = {
  GRADUATE_PROGRAM: 'GRADUATE_PROGRAM' as ProgramType,
  GRADUATE_GROUP: 'GRADUATE_GROUP' as ProgramType,
  PROFESSIONAL_PROGRAM: 'PROFESSIONAL_PROGRAM' as ProgramType,
  DESIGNATED_EMPHASIS: 'DESIGNATED_EMPHASIS' as ProgramType,
  GRADUATE_CERTIFICATE: 'GRADUATE_CERTIFICATE' as ProgramType
};



// WEBPACK FOOTER //
// ./src/gs-core/common/models/program-type.ts